/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DeviceEventSummary } from './DeviceEventSummary';
import {
    DeviceEventSummaryFromJSON,
    DeviceEventSummaryFromJSONTyped,
    DeviceEventSummaryToJSON,
    DeviceEventSummaryToJSONTyped,
} from './DeviceEventSummary';

/**
 * 
 * @export
 * @interface ListDeviceEventsResponse
 */
export interface ListDeviceEventsResponse {
    /**
     * 
     */
    events: Array<DeviceEventSummary>;
    /**
     * 
     */
    totalsPerType: { [key: string]: number; };
}

/**
 * Check if a given object implements the ListDeviceEventsResponse interface.
 */
export function instanceOfListDeviceEventsResponse(value: object): value is ListDeviceEventsResponse {
    if (!('events' in value) || value['events'] === undefined) return false;
    if ((!('totalsPerType' in (value as Record<string, any>)) && !('totals_per_type' in (value as Record<string, any>))) || ((value as Record<string, any>)['totalsPerType'] === undefined && (value as Record<string, any>)['totals_per_type'] === undefined)) return false;
    return true;
}

export function ListDeviceEventsResponseFromJSON(json: any): ListDeviceEventsResponse {
    return ListDeviceEventsResponseFromJSONTyped(json, false);
}

export function ListDeviceEventsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListDeviceEventsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'events': ((json['events'] as Array<any>).map(DeviceEventSummaryFromJSON)),
        'totalsPerType': json['totals_per_type'],
    };
}

export function ListDeviceEventsResponseToJSON(json: any): ListDeviceEventsResponse {
    return ListDeviceEventsResponseToJSONTyped(json, false);
}

export function ListDeviceEventsResponseToJSONTyped(value?: ListDeviceEventsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'events': ((value['events'] as Array<any>).map(DeviceEventSummaryToJSON)),
        'totals_per_type': value['totalsPerType'],
    };
}

